import { render } from "./EmailInputDropdown.vue?vue&type=template&id=5d56ba49&scoped=true"
import script from "./EmailInputDropdown.vue?vue&type=script&lang=js"
export * from "./EmailInputDropdown.vue?vue&type=script&lang=js"

import "./EmailInputDropdown.vue?vue&type=style&index=0&id=5d56ba49&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d56ba49"]])

export default __exports__